
import './style/App.css';
import './style/typography.css'
import './style/navigator.css'

import {NavBar} from './NavBar.jsx';
import {Home} from './Home.jsx';
import {About} from "./About.jsx";
import {Projects} from './Projects.jsx';
import {Visual} from "./Visual.jsx";
import {Contact} from './Contact.jsx';

import {
  HashRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";


function App() {
  return (
    <div className="App" id="bg">
      <header className="content">
        <Router>
          <NavBar/>
          <Switch>
            <Route path="/about">
              <About/>
            </Route>
            <Route path="/projects">
              <Projects/>
            </Route>
            <Route path="/visual">
              <Visual/>
            </Route>
            <Route path="/contact">
              <Contact />
            </Route>
            <Route path="/">
              <Home/>
            </Route>
          </Switch>
        </Router>
      </header>
    </div>
  );
}

export default App;
